module.exports = __webpack_public_path__ + "img/cargo-wagon-door-vertical-top.2dbe083a.png";